import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

type LoginData = {
  nombreUsuario: string;
  password: string;
};

export const useLogin = () => {
  return useMutation({
    mutationFn: async (data: LoginData) => {
      const response = await axiosInstance.post("/auth/login", data);
      return response.data;
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
